/* eslint-disable max-len */
import hamidProfileWebp from '../../../assets/images/hamid_kazemi.webp';
import hamidProfileJpg from '../../../assets/images/hamid_kazemi.jpg';
import maryamProfileWebp from '../../../assets/images/maryam_novinfar.webp';
import maryamProfileJpg from '../../../assets/images/maryam_novinfar.jpg';
import bardiaProfileWebp from '../../../assets/images/bardia_mirzaei.webp';
import bardiaProfileJpg from '../../../assets/images/bardia_mirzaei.jpg';

const comments = [
  {
    name: 'حمید کاظمی',
    jobTitle: 'مدیر واحد ارتباط با مشتریان',
    profileImageWebp: hamidProfileWebp,
    profileImageJpg: hamidProfileJpg,
    text: `مهم‌ترین ویژگی تپسی برای من اینه که به شدت امکان رشد و یادگیری بهم داده. علیرغم اینکه من در ورود به شرکت تجربه کمی داشتم، به من کاملا اعتماد کردن و مسئولیت‌های  مهمی رو به عهده‌ام گذاشتن.
این رویکرد باعث شد توی این ۵ سال در تپسی از خطا کردن نترسم و تجربه کنم و یاد بگیرم. به دور از شعار و از صمیم قلب می‌گم تپسی برای من خانواده‌ است.
از نظر من حمل و نقل بخش مهمی از جامعه‌ است و من به عنوان عضوی از تپسی، یکی از بزرگترین مجموعه‌های فعال توی این صنعت، حس فوق‌العاده‌ای از حضور در این بخش مهم دارم. حس تاثیرگذاری.
`,
  },
  {
    name: 'مریم نوین‌فر',
    jobTitle: 'سرپرست مرکز تماس',
    profileImageWebp: maryamProfileWebp,
    profileImageJpg: maryamProfileJpg,
    text: `تپسی برای من مثل دانشگاهه. تمام این سال‌ها از محیط به شدت پویای تپسی یاد گرفتم و هیچوقت حس نکردم دیگه جایی برای پیشرفت توی تپسی وجود نداره. به نظر من یکی از ارزشمندترین ویژگی‌های تپسی اینه که برای ارتقا و آموزش تیمش هزینه می‌کنه.
توی تپسی رفتار سازمانی خیلی اهمیت داره و رفتار سازمانی حرفه‌ای رو بین تمام بچه‌های تیم میشه دید.
توی تپسی به من اعتماد شد، با اشتباهاتم کنار گذاشته نشدم و برای اثرگذاری‌های مثبتم تشویق شدم.
`,
  },
  {
    name: 'بردیا میرزایی',
    jobTitle: 'مدیر محصول',
    profileImageWebp: bardiaProfileWebp,
    profileImageJpg: bardiaProfileJpg,
    text: `از نظر من یکی از مهم‌ترین آورده‌های تپسی برای اعضای تیمش، توسعه فردیه. سرعت رشد مجموعه تپسی به شدت بالاست و این باعث می‌شه تپسی، تک تک افراد رو همراه با خودش رو به جلو، پیش ببره و باعث رشد اون‌ها بشه.
تپسی جامعه هدف بزرگی داره و اینجا، هر قدمی که برمی‌داری یک تاثیر مستقیم یا غیرمستقیم بر زندگی افرادی می‌ذاره که به صورت روزمره با تپسی سروکار دارن و این یک تجربه فوق‌العاده جذابه.
تپسی دنبال خلق ارزشه و برای همین افرادی رو جذب می‌کنه که همین رویکرد رو دارن و برای حل مسئله و باز کردن گره‌ها اشتیاق و علاقه دارن.
`,
  },
];

export default comments;
